var map = {
	"./number-1.svg": 711,
	"./number-2.svg": 712,
	"./number-3.svg": 713,
	"./number-4.svg": 714,
	"./number-5.svg": 715,
	"./number-6.svg": 716,
	"./number-7.svg": 717,
	"./number-8.svg": 718,
	"./number-9.svg": 719,
	"./number-shine-1.svg": 720,
	"./number-shine-2.svg": 721,
	"./number-shine-3.svg": 722,
	"./number-shine-4.svg": 723,
	"./number-shine-5.svg": 724,
	"./number-shine-6.svg": 725,
	"./number-shine-7.svg": 726,
	"./number-shine-8.svg": 727,
	"./number-shine-9.svg": 728
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 710;